import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// components
import { viewMore } from '../../pdpMessages';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

// styles
import styles from './PdpRespSimilarItemsContainer.scss';

function PdpRespSimilarItemsContainer(props) {
    const {
        header,
        subtitle,
        children,
        dataTn,
        gridWrapperClass,
        isHorizontal,
        ...options
    } = props;
    const wrapperClass = classnames(styles.wrapper, {
        [styles.hasSubtitle]: !!subtitle,
        [styles.hideBar]: options.hideBar,
        [styles.isTopContainer]: options.isTopContainer,
    });
    const contentClass = classnames(styles.content, gridWrapperClass, {
        [styles.isHorizontal]: isHorizontal,
    });
    const subtitleClass = classnames(styles.subtitle, { [styles.hasHeader]: !!header });

    const pageLayoutProps = {
        setViewportBackground: options.isDark, // to set the default dark viewport background
        // to remove the offets so that the the default layout would be coming from main PDP container
        setOffset: options.isDark,
    };

    return (
        <PageLayout {...pageLayoutProps} dataTn={dataTn}>
            <div className={wrapperClass}>
                {/* Header */}
                {!!header && <BarHeader title={header} />}

                {/* FULL WIDTH OF PAGE */}
                <div className={contentClass} data-tn="pdp-similar-items">
                    {!!subtitle && (
                        <div className={subtitleClass}>
                            {subtitle}{' '}
                            <span
                                className={styles.viewMore}
                                onClick={options.onClickViewMore}
                                data-tn="view-more-similar-items"
                            >
                                {viewMore}
                            </span>
                        </div>
                    )}
                    {/* Grid of Items */}
                    {children}
                </div>
            </div>
        </PageLayout>
    );
}

PdpRespSimilarItemsContainer.propTypes = {
    header: PropTypes.node,
    subtitle: PropTypes.node,
    children: PropTypes.node,
    gridWrapperClass: PropTypes.string,
    dataTn: PropTypes.string.isRequired,

    // options
    isDark: PropTypes.bool,
    isHorizontal: PropTypes.bool,
    hideBar: PropTypes.bool,
    onClickViewMore: PropTypes.func,
    isTopContainer: PropTypes.bool,
};

export { PdpRespSimilarItemsContainer };
